import { writable } from "svelte/store";
export const scrollStore = writable({});
export const hasScrolledStore = writable(false);
export const headerBackground = writable(true);
export const projectStore = writable({});
export const HDRItexture = writable({});
